"use client";

import styles from "./AuthorizeIsAuthenticated.module.scss";

import { logoutUser } from "@/helpers";
import { useAuth } from "@/hooks";

import { useAuthorizeForm } from "../../_hooks";
import {
  Button,
  Flex,
} from "@vetty/ui";

/**
 * AuthorizeIsAuthenticated Component
 *
 * Displays a message when the user is already authenticated.
 */
export const AuthorizeIsAuthenticated = () => {
  const { user } = useAuth();
  const { submitAuthorize, loading, authError } = useAuthorizeForm();

  const handleLogout = async () => {
    await logoutUser();
    window.location.reload();
  };

  return (
    <Flex
      className={styles["comp"]}
      align={"center"}
      justify={"center"}
      direction={"column"}
      gap={56}
    >
      <Flex direction={"column"} gap={10} align={"center"}>
        <h2 className={styles["comp__title"]}>You are already logged in as</h2>
        <p className={styles["comp__email"]}>{user?.email}</p>
      </Flex>

      <Flex direction={"column"} gap={16} style={{ width: "100%" }}>
        {authError && (
          <div
            style={{
              fontSize: "16px",
              color: "#ef4444",
              textAlign: "center",
              background: "#fee2e2",
              padding: "12px 16px",
              borderRadius: "8px",
              border: "1px solid #fecaca",
            }}
          >
            {authError}
          </div>
        )}

        <Flex direction={"column"} gap={8}>
          <Button
            disabled={loading}
            loading={loading}
            onClick={submitAuthorize}
            className={styles["comp__button"]}
          >
            Authorize
          </Button>

          <button onClick={handleLogout} className={styles["comp__logout"]}>
            Logout
          </button>
        </Flex>
      </Flex>
    </Flex>
  );
};
